<div>
    <div class="round-map" #mapContainer>
        <div [style.transform]="translate" (click)="mapEventsEnabled=true" (mouseleave)="mapEventsEnabled=false">
            <iframe
                #defaultMap
                height="{{mapFrameHeight}}px"
                width="150%"
                src="assets/html/map-inner.html"
                [style.transform]="rotate"
                [style.pointer-events]="mapEventsEnabled?'auto':'none'">
            </iframe>
        </div>
        <img src="https://maps.gstatic.com/mapfiles/api-3/images/google4.png" style="position: absolute; bottom: 12px; left: 24px;">

        <div class="map-control">
            <div class="zoom-btn" (click)="zoomIn()"></div>
            <div class="zoom-btn" (click)="zoomOut()"></div>
        </div>
    </div>
</div>
